// @flow
import React from 'react';
import cx from 'classnames';

import './FakeBannerCard.scss';
import Bannerpone from '../Bannerpone/Bannerpone';

type Props = {
  oneColumn?: boolean,
};

const FakeBannerCard = ({ oneColumn }: Props) => (
  <Bannerpone duration={100}>
    <div className={cx('BannerCard FakeBannerCard', { 'one-column': oneColumn })}>
      <div className="thumbnail-wrapper">
        <img
          src="https://images.cacheby.com/placeholder.png?s=600x316&t=crop&q=82&f=webp"
          alt="thumbnail"
        />
      </div>
    </div>
  </Bannerpone>
);

FakeBannerCard.defaultProps = {
  oneColumn: false,
};

export default FakeBannerCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeBannerCard/FakeBannerCard.js